import axios from "axios";
import { Socket } from "phoenix";

// const API_URL = "http://localhost:4000/api/v1/";
// const API_URL = "https://dev-katundu360-api.afrocentec.com/api/v1"; //dev
// const API_URL = "https://katundu360-api.afrocentec.com/api/v1"; //Prod
const API_URL = "https://katundu-api.afrocentec.com/api/v1"; // New Prod



// Create a function for making API requests
export const makeNoAuthApiRequest = (method, endpoint, data = null) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
  const config = {
    method,
    url: `${API_URL}/${endpoint}`,
    headers,
  };
  if (data)
  {
    if (method === "get")
    {
      config.params = data;
    } else
    {
      config.data = data;
    }
  }

  return axios(config);
};

// Tenat No Auth API Helper
export const makeTenantNoAuthApiRequest = (method, endpoint, data = null) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json, multipart/form-data",
  };

  if (localStorage.getItem("dashboard_access"))
  {
    headers["Authorization"] = `Bearer ${JSON.parse(localStorage.getItem("dashboard_access"))}`;
  }

  let config = {
    method,
    url: API_URL + endpoint,
    headers,
  };

  if (data)
  {
    if (method === "get")
    {
      config.params = data;
    } else
    {
      config.data = data;
    }
  }

  return axios(config);
};

// Tenat No Auth API Helper
export const makeTenantAuthApiRequest = (method, endpoint, data = null) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json, multipart/form-data",
  };

  const dashboardAccess = localStorage.getItem("dashboard_access");
  const profileAccess = localStorage.getItem("profile_access");

  if (dashboardAccess)
  {
    headers["Authorization"] = `Bearer ${JSON.parse(dashboardAccess)}`;
  }

  if (profileAccess)
  {
    headers["X-Authorization-2"] = `Bearer ${JSON.parse(profileAccess)}`;
  }

  let config = {
    method,
    url: API_URL + endpoint,
    headers,
  };

  if (data)
  {
    if (method === "get")
    {
      config.params = data;
    } else
    {
      config.data = data;
    }
  }

  return axios(config);
};

export const authEmployeeSocketApiConnectionHelper = async () => {

  const dashboardAccess = localStorage.getItem("dashboard_access");
  const profileAccess = localStorage.getItem("profile_access");
  const tenant_url_prefix = window.location.pathname.split("/")[1] || "";

  if (!(tenant_url_prefix && dashboardAccess && profileAccess))
  {
    console.warn("⚠️ No auth token found. Cannot establish socket connection.");
    return null;
  }

  const socket = new Socket(`${API_URL}/socket/employee/auth`, {
    params: { dashboardAccess: JSON.parse(dashboardAccess), profileAccess: JSON.parse(profileAccess), tenant_url_prefix },
  });

  socket.connect();

  // ✅ Wait for connection if not yet ready
  const isConnected =
    typeof socket.isConnected === "function"
      ? socket.isConnected()
      : socket.conn && socket.conn.readyState === 1;

  if (!isConnected)
  {
    console.warn("⚠️ Socket not yet connected — waiting to open...");

    try
    {
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
          reject(new Error("Socket connection timeout"));
        }, 5000);

        socket.onOpen(() => {
          clearTimeout(timeout);
          console.log("✅ Socket connected after waiting");
          resolve(true);
        });

        socket.onError(() => {
          clearTimeout(timeout);
          reject(new Error("Socket connection failed"));
        });
      });
    } catch (err)
    {
      console.error("❌ Failed to establish socket connection:", err.message);
      return null;
    }
  }

  console.log("✅ Socket Connected and Ready");
  return socket;
};